import { render, staticRenderFns } from "./Nadim.vue?vue&type=template&id=3f7945b8&scoped=true&"
import script from "./Nadim.vue?vue&type=script&lang=js&"
export * from "./Nadim.vue?vue&type=script&lang=js&"
import style0 from "./Nadim.vue?vue&type=style&index=0&id=3f7945b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7945b8",
  null
  
)

export default component.exports